'use client';

import NextForm, { type FormProps } from 'next/form';
import type { PropsWithChildren, ReactNode } from 'react';
import { Form } from 'react-bootstrap';
import { addClassName } from './addClassName';
import { FormAtomsProvider } from './FormAtomsContext';
import { useFormValidated, useIsFormDisabled } from './useFormValidated';
import styles from './ValidatedForm.module.scss';

export interface ValidatedFormProps extends PropsWithChildren {
	formProps?: FormProps;
}

function FormContent(props: ValidatedFormProps): ReactNode {
	const formValidated = useFormValidated();
	const formDisabled = useIsFormDisabled();

	// Add disabled class if needed
	let className = props.formProps?.className;
	if (formDisabled) {
		className = addClassName(className, styles['disabled']);
	}

	return (
		<Form {...props.formProps} className={className} validated={formValidated} as={NextForm}>
			{props.children}
		</Form>
	);
}

export function ValidatedForm(props: ValidatedFormProps): ReactNode {
	return (
		<FormAtomsProvider>
			<FormContent {...props} />
		</FormAtomsProvider>
	);
}
